import React from 'react';
import { Button, Col, DatePicker, Row, Space } from 'antd';
import moment from 'moment';
import { DATE_FORMAT } from '../inventoryData';

const { RangePicker } = DatePicker;

/**
 * 房型庫存查詢的篩選列。只有日期區間 —— 房型一律全部顯示，因為業務多半是先鎖定日期
 * 再橫向比較各房型，額外的房型篩選反而多一道操作。
 *
 * 區間上限與後端 ValidatesInventoryRange 的 $inventoryMaxDays 一致，
 * 超出時直接在前端擋下，免得使用者按下查詢才吃到 422。
 */
export const MAX_DAYS = 124;

export default function InventoryFilter({
  range,
  loading = false,
  onRangeChange,
  onQuery,
}) {
  const tooLong = range && range[0] && range[1]
    && range[1].diff(range[0], 'days') + 1 > MAX_DAYS;

  return (
    <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 16 }}>
      <Col>
        <Space>
          <span>日期區間</span>
          <RangePicker
            value={range}
            format={DATE_FORMAT}
            allowClear={false}
            onChange={onRangeChange}
          />
        </Space>
      </Col>
      <Col>
        <Button type="primary" loading={loading} disabled={tooLong} onClick={onQuery}>
          查詢
        </Button>
      </Col>
      {tooLong && (
        <Col span={24}>
          <span style={{ color: '#ff4d4f' }}>查詢區間不可超過 {MAX_DAYS} 天</span>
        </Col>
      )}
    </Row>
  );
}

// 預設最近 3 天 (含今天)。庫存看的是「還能不能賣」，所以是往後算，不是往前。
export const DEFAULT_DAYS = 3;

export const defaultRange = () => [moment(), moment().add(DEFAULT_DAYS - 1, 'days')];
